export enum deleteActionsForSiteTypeEnum {
  'twitter' = 'twitter_delete_self_answer',
  'facebook' = 'facebook_delete_self_answer',
  'instagram2' = 'instagram2-delete-self-answer',
  'linkedin' = 'linkedin-delete-self-answer',
  'tiktok' = 'tiktok-delete-self-answer',
}
